import { render } from "./StudySaveStatus.vue?vue&type=template&id=6157702c&scoped=true"
import script from "./StudySaveStatus.vue?vue&type=script&lang=js"
export * from "./StudySaveStatus.vue?vue&type=script&lang=js"

import "./StudySaveStatus.vue?vue&type=style&index=0&id=6157702c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6157702c"]])

export default __exports__